import { jsxs as e, jsx as l } from "react/jsx-runtime";
function n() {
  return /* @__PURE__ */ e(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 40 40",
      height: "40",
      width: "40",
      children: [
        /* @__PURE__ */ l("defs", { id: "defs6" }),
        /* @__PURE__ */ l(
          "g",
          {
            transform: "scale(0.17), matrix(1.3333333,0,0,-1.3333333,-0.41406266,176.42504), translate(0,-30)",
            id: "g10",
            children: /* @__PURE__ */ e("g", { transform: "scale(0.1)", id: "g12", children: [
              /* @__PURE__ */ l(
                "path",
                {
                  id: "path52",
                  style: {
                    fill: "#231f20",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none"
                  },
                  d: "m 66.3438,1271.99 c 46.7652,-90.34 157.8322,-90.34 250.2972,-94.06 178.558,3.72 379.433,12.22 481.996,-147.73 29.761,-53.677 37.734,-115.856 40.39,-180.688 l 0.176,-580.84 H 791.73 C 792.227,430.734 775.789,530.66 670.035,603.996 634.43,630.566 594.938,633.34 546.215,641.727 395.191,667.727 213.547,612.5 93.9766,725.691 13.1992,802.746 3.01563,914.344 3.54688,1025.41 l -0.44141,275.28 c 3.1875,9.56 5.84375,18.6 15.94143,21.78 34.5429,6.38 34.0117,-31.35 47.2969,-50.48",
                  "inkscape:connector-curvature": "0"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  id: "path54",
                  style: {
                    fill: "#1a5dad",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none"
                  },
                  d: "m 1704.27,1268.38 -0.09,-324.275 C 1701.52,839.945 1652.1,734.195 1556.45,685.836 1416.15,619.938 1227.5,674.676 1079.76,643.32 982.508,608.777 887.918,522.688 885.793,411.09 c -1.594,-3.719 -5.316,-1.594 -7.973,-2.125 l -0.617,3.187 -0.445,535.141 c 11.691,87.687 74.398,162.617 155.172,198.747 33.48,12.76 70.15,22.32 106.28,26.04 l 435.24,1.6 c 57.92,5.31 108.94,49.95 125.41,102.03 7.44,-0.53 3.28,-1.48 5.41,-7.33",
                  "inkscape:connector-curvature": "0"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  id: "path56",
                  style: {
                    fill: "#ffffff",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none"
                  },
                  d: "m 1688.23,1073.77 c -6.9,-29.76 -23.91,-55.27 -52.6,-70.14 -26.58,-13.294 -56.34,-17.544 -87.16,-18.607 l -319.38,1.594 c -1.59,55.803 -1.59,117.973 0,169.523 l 342.23,1.06 c 47.3,4.79 92.56,27.64 117.53,68.03 l -0.62,-151.46",
                  "inkscape:connector-curvature": "0"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  id: "path58",
                  style: {
                    fill: "#17ae65",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none"
                  },
                  d: "m 309.73,1130.1 c 159.961,-10.63 357.649,27.1 443.208,-130.194 54.566,-71.629 31.98,-205.812 36.667,-457.554 v -3.719 C 754.531,631.098 655.156,684.242 561.094,692.742 461.188,698.59 352.246,703.371 255.531,706.027 165.188,711.875 93.9766,786.805 68.4688,869.176 39.6055,1009.32 54.2188,1195.32 50.4023,1213.54 108.324,1131.7 215.141,1134.88 309.73,1130.1",
                  "inkscape:connector-curvature": "0"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  id: "path60",
                  style: {
                    fill: "#ffffff",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none"
                  },
                  d: "M 1086.67,982.898 C 999.516,964.301 920.867,897.34 890.574,815.5 c -2.027,142.004 4.614,188.5 61.742,254.93 38.528,41.19 100.344,70.3 134.354,77.74 V 982.898",
                  "inkscape:connector-curvature": "0"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  id: "path62",
                  style: {
                    fill: "#ffffff",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none"
                  },
                  d: "m 1537.84,694.867 c -88.74,-41.449 -205.04,-21.254 -309.2,-26.57 l 0.45,172.18 324.7,1.066 c 55.8,3.187 110.53,40.387 133.38,91.934 -1.06,-98.313 -54.74,-196.625 -149.33,-238.61",
                  "inkscape:connector-curvature": "0"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  id: "path64",
                  style: {
                    fill: "#ffffff",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none"
                  },
                  d: "m 1086.23,666.172 c -19.67,-9.035 -40.48,-18.598 -61.21,-27.633 -60.047,-31.355 -114.25,-85.559 -135.508,-149.328 5.843,77.586 -17.004,174.305 28.695,238.605 38.793,58.989 99.373,101.5 168.463,109.473 l -0.44,-171.117",
                  "inkscape:connector-curvature": "0"
                }
              )
            ] })
          }
        )
      ]
    }
  );
}
export {
  n as default
};
